import React, { Fragment, ReactNode } from 'react';
import { List } from '@mos-cat/typography';

interface Props {
  content: ReactNode;
  listTitle?: ReactNode;
  list?: ReactNode[];
  contentAfter?: ReactNode;
}

export default function StepContent(props: Props): JSX.Element {
  return (
    <Fragment>
      {props.content}
      {props.listTitle && (
        <div className="MainSteps-step__text">{props.listTitle}</div>
      )}
      {props.list && (
        <List className="MainSteps-step__list">
          {props.list.map((item, index) => (
            <List.Item key={index}>{item}</List.Item>
          ))}
        </List>
      )}
      {props.contentAfter}
    </Fragment>
  );
}
